module.exports = __webpack_public_path__ + "static/media/about-us-work.12387095.png";